import { getMobileAuthHeaders } from './mobileAuth';

export default getMobileAuthHeaders;
